export default __webpack_public_path__ + "static/media/arrow-trending-up.4a1d9a34.svg";